import { createContext } from 'react';

const LSContext = createContext();

export default LSContext;
